import {
  ArticleSelectIcon,
  EventSelectIcon,
  GallerySelectIcon,
  ImageGallery,
  PollsSelectIcon,
  QuizSelectIcon,
  VideoGallerySelectIcon,
  VODSelectIcon,
} from "@platformx/shared/static-assets";

export const TAG_WINDOW_SIZE = 10;
export const TAG_SEARCH_THRESHOLD = TAG_WINDOW_SIZE;
export const TAG_SEARCH_DEBOUNCE_MS = 400;

export const CATEGORY_INITIAL_TAGS_ROWS = 1000;

/** View modes for the content picker's results area. Thumbnail is the default. */
export const GALLERY_VIEW_MODES = {
  THUMBNAIL: "thumbnail",
  LIST: "list",
} as const;

export const contentIconMap = {
  ARTICLE: <img alt='settings' src={ArticleSelectIcon} />,
  POLL: <img alt='settings' src={PollsSelectIcon} />,
  QUIZ: <img alt='settings' src={QuizSelectIcon} />,
  IMAGEGALLERY: <img alt='settings' src={ImageGallery} />,
  VIDEOGALLERY: <img alt='settings' src={VideoGallerySelectIcon} />,
  EVENT: <img alt='settings' src={EventSelectIcon} />,
  GALLERY: <img alt='settings' src={GallerySelectIcon} />,
  VOD: <img alt='settings' src={VODSelectIcon} />,
};
